import { useContext, createContext } from 'react';

import type { AppConfiguration } from '../types';

export const configurationContext = createContext<AppConfiguration>({
  identityUrl: '',
  apiUrl: '',
  tenant: '',
  graphqlUrl: '',
  appUrl: '',
  orgId: '',
  deploymentId: '',
  queue: '',
  firstName: '',
  lastName: '',
  email: '',
  customerId: -1,
  dataURL: '',
  title: '',
  scriptPath: 'https://apps.mypurecloud.de/widgets/9.0/cxbus.min.js',
  pluginsPath: 'https://apps.mypurecloud.de/widgets/9.0/plugins/',
  language: 'en',
  consultantNumber: 0,
  phoneNumber: '',
  buttonLabel: '',
  dedicatedPage: false,
  maxMessageLength: 500,
});

export const ConfigurationProvider = configurationContext.Provider;

export const useConfiguration = () => useContext(configurationContext);
